import React from "react";
import "./comparisonFeatures.css";

const DetailedComparisonTable = ({ features, platform, savings = "", note = "" }) => {

    return (<div className="comparison-table table-striped">
            <table>
                <thead>
                    <tr>
                        <th className="comparison-topic">&nbsp;</th>
                        <th className="comparison-title">Realtor Real Estate</th>
                        <th className="comparison-title">{platform}</th>
                    </tr>
                </thead>
                <tbody>
                    {features.map((feature, index) => (
                        <tr key={index}>
                            <td className="comparison-topic">
                                {feature.name}
                            </td>
                            <td className="comparison-title">
                                {feature?.realtor ? feature?.realtor === "Yes" ? (<i className="fa fa-check" />) : feature?.realtor === "No" ? (<i className="fa fa-multiply" />) : (feature?.realtor) : (<i className="fa fa-check" />)}
                            </td>
                            <td className="comparison-title">
                                {feature.type === "Yes" ? (<i className="fa fa-check" />) : feature.type === "No" ? (<i className="fa fa-multiply" />) : (feature.type)}
                            </td>
                        </tr>
                    ))}
                    {savings !== "" && (
                        <tr>
                            <td className="comparison-topic">Total Savings</td>
                            <td colSpan={2} className="comparison-savings">{savings}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {note !== "" && (
                <p className="table-bottom-notes">{note}</p>
            )}
        </div>);
};

export default DetailedComparisonTable;
